import { render, staticRenderFns } from "./border-comp1.vue?vue&type=template&id=522dad5d"
var script = {}
import style0 from "./border-comp1.vue?vue&type=style&index=0&id=522dad5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports